/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {NumberFiledsValidatorDirective as ɵj} from './lib/directives/number-field.directive';
export {IDGSEnvironment as ɵd} from './lib/models/environment';
export {init_app as ɵa} from './lib/modules/dgs-core.module';
export {DGSLowerTranslatePipe as ɵb} from './lib/pipes/translate.pipe';
export {ApiService as ɵe} from './lib/services/api.service';
export {FactoryService as ɵg} from './lib/services/factory.service';
export {DGSNotificationService as ɵh} from './lib/services/notification.service';
export {AppConfigService as ɵc} from './lib/services/settings.service';
export {StorageService as ɵf} from './lib/services/storage.service';
export {DGSLoadingComponent as ɵi} from './ui/components/loading/loading.component';